import config from '../config/config';

const PREF_CODE_PADDING = config.weather.prefCodePadding;
const CITY_CODE_PADDING = config.weather.cityCodePadding;

// DOM定数
const SCRIPT_TAG = config.common.domTags.script;

/**
 * 天気情報取得関数
 */
export function fetchWeather(lat, lon) {
  return new Promise((resolve) => {
    // グローバルスコープにコールバック関数を定義
    window.weatherCallback = function (data) {
      try {
        if (data?.mbml?.MwnList?.Mwn?.Pnts?.PinpointList?.Pinpoint) {
          const mwnData = data.mbml.MwnList.Mwn;
          const currentWeather = mwnData.Pnts.PinpointList.Pinpoint[0];

          // 地域コードを追加
          currentWeather.kencode = mwnData.kencode;
          currentWeather.citycode = mwnData.citycode;
          currentWeather.kenname = mwnData.kenname;
          currentWeather.cityname = mwnData.cityname;

          resolve(currentWeather);
        } else {
          resolve(null);
        }
      } catch (error) {
        resolve(null);
      } finally {
        // コールバックの後片付け（グローバル汚染防止）
        try {
          delete window.weatherCallback;
        } catch (e) {
          window.weatherCallback = undefined;
        }
      }
    };

    // APIにアクセスするURLに緯度経度をセット
    const url = config.api.weather(lon, lat);
    const script = document.createElement(SCRIPT_TAG);
    script.src = url;

    // エラーハンドリング
    script.onerror = () => {
      // エラー時も後片付け
      try {
        delete window.weatherCallback;
      } catch (e) {
        window.weatherCallback = undefined;
      }
      try {
        document.body.removeChild(script);
      } catch (e) {
      }
      resolve(null);
    };

    // スクリプト読み込み後の処理
    script.onload = function () {
      document.body.removeChild(script);
    };

    document.body.appendChild(script);
  });
}

// 天気データから地域コードを取得してMapion天気ページのURLを生成
export function getWeatherPageURL(weatherData) {
  if (!weatherData) {
    return null;
  }
  // 地域コードを取得（複数のパターンに対応）
  const prefCode = weatherData.kencode || weatherData.pref_code || weatherData.prefCode;
  const cityCode = weatherData.citycode || weatherData.city_code || weatherData.cityCode;

  if (prefCode && cityCode) {
    // コードを文字列として扱い、必要に応じてゼロパディング
    const prefCodeStr = String(prefCode).padStart(PREF_CODE_PADDING, '0');
    const cityCodeStr = String(cityCode).padStart(CITY_CODE_PADDING, '0');

    const weatherPageUrl = config.urls.weatherPageUrl(prefCodeStr, cityCodeStr);
    return weatherPageUrl;
  }
  return null;
}